import React, { Component } from 'react';

// Elements
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import SectionHeading from '../SectionHeading/SectionHeading';

export default class Features extends Component {

    render() {
        let features = this.props.features;
        if(features === undefined) {
            return <></>
        }
        return (
        <section className="features-modern">
            <Container>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <SectionHeading title={features.title} as="h1" className="features-title"/>
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col lg={7} md={12} sm={12} xs={12}>
                        <div className="features-grid">
                        {features.features.map((feature, index) => (
                            <div className="features-card wow fadeInUp" data-wow-delay={`${0.1 * (index + 1)}s`} key={index}>
                                <span className="features-card__icon"><i className="fa-solid fa-check"></i></span>
                                <h3 className="features-card__title">{feature.title}</h3>
                                <p className="features-card__text">{feature.text}</p>
                            </div>
                        ))}
                        </div>
                    </Col>
                    <Col lg={5} md={12} sm={12} xs={12} className='wow fadeInUp' data-wow-delay='0.4s'>
                        <div className="features-media">
                            <img src={features.image} alt="featured" className='features-media__img'/>
                            {features.link !== undefined?
                            <a href={features.link.url} className='text-link'>{features.link.text} <i className="fa-solid fa-arrow-right"></i></a>
                            :null}
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
        );
    }
}
